import { TRow } from "../listing-table.types";
import { ProductImage } from "../../../../features/products/components/product-image/product-image.component";
import React from "react";

export const Product = (row: TRow) => <ProductImage imageUrl={row?.image} title="" />;
